"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./Icon"));
var __jsx = _react.default.createElement;
var CaretLeftIcon = function CaretLeftIcon(props) {
  return __jsx(_Icon.default, (0, _extends2.default)({
    width: 11,
    height: 20
  }, props), __jsx("path", {
    d: "M8.8 20a2.16 2.16 0 01-1.67-.78l-6.6-7.77a2.24 2.24 0 010-2.9L7.13.77a2.19 2.19 0 013.1-.24 2.25 2.25 0 01.24 3.14L5.1 10l5.37 6.33a2.24 2.24 0 01-.24 3.13A2.16 2.16 0 018.8 20z"
  }));
};
var _default = CaretLeftIcon;
exports.default = _default;